import { Component, Input, OnInit } from '@angular/core';
import { ISession } from '../../../../models/session';
import { IWidgetOptions } from '../stats';

@Component({
  selector: 'session-stats-histogram',
  template: `
    <div class="form-inline m-b-sm">
      <span class="m-r-sm">{{ options.title }}</span>
      <app-date-picker
        [(ngModel)]="options.filter.datefrom"
        [pickerType]="pickerType"
      ></app-date-picker>
      <span class="m-x-sm">{{ 'common.to' | translate }}</span>
      <app-date-picker
        [(ngModel)]="options.filter.dateto"
        [pickerType]="pickerType"
      ></app-date-picker>
    </div>
    <app-bar-chart
      [session]="session"
      [options]="options"
      [datefrom]="options.filter.datefrom"
      [dateto]="options.filter.dateto"
    ></app-bar-chart>
  `,
  styleUrls: ['../stats.component.scss']
})
export class StatsHistogramComponent implements OnInit {
  @Input('session') session: ISession;
  @Input('options') options: IWidgetOptions;

  public datefrom: Date;
  public dateto: Date;
  public pickerType: string;

  constructor() {}

  ngOnInit() {
    this.pickerType = this.options.pickerType ? this.options.pickerType : 'calendar';
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/stats/stats-histogram/stats-histogram.component.ts